import { post_1} from "../APIGateWay";

export async function getCourseGradebook(params = {}) {
  return await post_1(params,process.env.VUE_APP_CMS_API + "/itoteacher" + "/get_student_web_grade_book");
}

export async function getCourseCategory(params = {}) {
  return await post_1(params,process.env.VUE_APP_CMS_API + "/itolearning" + "/get_category");
}